import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { CorporateFare } from "@mui/icons-material";
import AccountBalance from '@mui/icons-material/AccountBalance';
import EventRepeat from '@mui/icons-material/EventRepeat';
import { doSetDarkPaletteMode, doSetLightPaletteMode, selectLayoutSettings } from '../user/userSlice';
import { useImmer } from 'use-immer';
import navigationPaths from '../../engine/navigationPaths';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { selectIsAdministrator, selectIsRegistered } from "../logon/logonSlice";
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';

export default function SettingsMenu() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const layoutSettings = useSelector(selectLayoutSettings);

    const [state, updateState] = useImmer({
        themeModeChecked: layoutSettings.paletteMode == 'dark'
    });

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isRegistered = useSelector(selectIsRegistered);
    const isAdministrator = useSelector(selectIsAdministrator);

    React.useEffect(() => {
        updateState((draft) => { 
            draft.themeModeChecked = (layoutSettings.paletteMode == 'dark');
        })
    }, [layoutSettings]);

    const handleClick = (event) => {
        onUserOrganizationSettingsClick();
        //setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onUserOrganizationSettingsClick = () => {
        handleClose();
        navigate(navigationPaths().Settings);
    }  

    const onThemeModeChange = (newValue) => {
        handleClose();

        updateState(draft => {
            draft.themeModeChecked = newValue;
        });

        if(newValue) {
            dispatch(doSetDarkPaletteMode());
        } else {
            dispatch(doSetLightPaletteMode());
        }
    }

    const onUserUsersClick = () => {
        handleClose();
        navigate(navigationPaths().UserUsersSettings);
    }

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="Ustawienia">
                    <IconButton
                        id='settings-menu-button'
                        onClick={handleClick}
                        size="small"
                        sx={{ mr: 2 }}
                        aria-controls={open ? 'settings-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <SettingsOutlinedIcon sx={{ width: 28, height: 28, color:'white' }} />
                    </IconButton>
                </Tooltip>
            </Box>
           
        </React.Fragment>
    );
}